module.exports = __webpack_public_path__ + "img/mirka-adventure.e7337679.webp";